import {
  __objRest,
  __spreadProps,
  __spreadValues,
  default_attributes_default
} from "./chunk-G6JHNJEL.js";

// create-icon.ts
import { forwardRef, createElement } from "react";
var toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
var createIcon = (iconName, iconNode) => {
  const Component = forwardRef(
    (_a, ref) => {
      var _b = _a, {
        color = "currentColor",
        size = 16,
        width: strokeWidth = 1,
        absolute,
        children,
        css = ""
      } = _b, rest = __objRest(_b, [
        "color",
        "size",
        "width",
        "absolute",
        "children",
        "css"
      ]);
      return createElement(
        "svg",
        __spreadValues(__spreadProps(__spreadValues({
          ref
        }, default_attributes_default), {
          width: size,
          height: size,
          stroke: color,
          strokeWidth: absolute ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
          className: `lucide lucide-${toKebabCase(iconName)} shrink-0 ${css}`
        }), rest),
        [
          ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
          ...(Array.isArray(children) ? children : [children]) || []
        ]
      );
    }
  );
  Component.displayName = `${iconName}`;
  return Component;
};
var create_icon_default = createIcon;

export {
  toKebabCase,
  create_icon_default
};
